module.exports = __webpack_public_path__ + "img/Back.591f27a.png";